var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.938 1.057-2.135 3.58a2 2 0 0 1-1.26.922L1.426 6.605 4.171 9.74a2 2 0 0 1 .488 1.483l-.278 4.239 3.831-1.641a2 2 0 0 1 1.562-.006l3.945 1.574-.377-4.151a2 2 0 0 1 .477-1.487l2.716-3.266-4.064-.924a2 2 0 0 1-1.266-.913L8.938 1.057Z",
    stroke: "#003E52",
    strokeWidth: 2,
    fill: "none"
  })));
};
export default SvgStar;